import { COMMON_COMPONENT } from '@/consts/base.js'

const common = {
  state: {
    isLoading: false,
    typeCache: {},
    loadingState: {}
  },
  actions: {
    async getCommonList ({ commit, state, rootState }, params) {
      const CACHE_EXPIRE_TIME = 1000 * 60 * 5
      const now = Date.now()
      const { type } = params || {}
      if (type === 1 || type === 2) {
        state.loadingState[type] = true
        try {
          const { list: commonList = [] } = rootState?.list.find(v => v.key === COMMON_COMPONENT)
          const cache = state.typeCache[type]
          if (cache && cache.timestamp > now - CACHE_EXPIRE_TIME && cache.list.length > 0) {
            commonList[0].list = [...commonList[0].list.filter(item => item.type !== type), ...cache.list]
            commit('UPDATE_LIST', rootState.list)
            state.loadingState[type] = false
            return
          }
          const res = await mm.dispatch('getCommonListSingle', { type })
          const { data = [] } = res?.list
          const detailPromises = data.map(item =>
            mm.dispatch('getCommonDetail', { id: item.id }).then(detail => ({ item, detail }))
          )
          const results = await Promise.all(detailPromises)
          results.forEach(({ item, detail }) => {
            const { content = {}, public_component_uuid, id, type: itemType, name } = detail?.info || {}
            content.isCommon = true
            content.public_component_uuid = public_component_uuid
            content.commonObj = { id, type: itemType, name }
            item.list = JSON.stringify(content) === '{}' ? [] : [content]
          })
          state.typeCache[type] = { list: data, timestamp: now }
          commonList[0].list = [...commonList[0].list.filter(item => item.type !== type), ...data]
          commit('UPDATE_LIST', rootState.list)
        } finally {
          state.loadingState[type] = false
        }
        return
      }
    },
    async getCommonTotalCount ({ state, rootState }) {
      const CACHE_EXPIRE_TIME = 1000 * 60 * 5
      const now = Date.now()
      let totalCount = 0
      if (state.typeCache[1] && state.typeCache[1].timestamp > now - CACHE_EXPIRE_TIME) {
        totalCount += state.typeCache[1].list.length
      } else {
        const res1 = await mm.dispatch('getCommonListSingle', { type: 1 })
        const count1 = res1?.list?.data?.length || 0
        totalCount += count1
        if (res1?.list?.data) {
          state.typeCache[1] = { list: res1.list.data, timestamp: now }
        }
      }
      if (state.typeCache[2] && state.typeCache[2].timestamp > now - CACHE_EXPIRE_TIME) {
        totalCount += state.typeCache[2].list.length
      } else {
        const res2 = await mm.dispatch('getCommonListSingle', { type: 2 })
        const count2 = res2?.list?.data?.length || 0
        totalCount += count2
        if (res2?.list?.data) {
          state.typeCache[2] = { list: res2.list.data, timestamp: now }
        }
      }
      return totalCount
    },
    getCommonListSingle ({ commit, rootState }, params) {
      return mm.http({
        url: '/api/publicComponent/list',
        method: 'get',
        loading: false,
        params
      }).then(({ data }) => data)
    },
    postCommonAdd({ commit, state }, data) {
      return mm.http({
        url: '/api/publicComponent/createPost',
        method: 'post',
        data
      }).then(({ data }) => {
        state.typeCache = {}
        return data
      })
    },
    postCommonDelete({ commit, state }, params) {
      return mm.http({
        url: '/api/publicComponent/delete',
        method: 'post',
        params: { ...params }
      }).then(({ data }) => {
        state.typeCache = {}
        return data
      })
    },
    getCommonDetail({ commit, state }, params) {
      return mm.http({
        url: '/api/publicComponent/info',
        method: 'get',
        loading: false,
        params: { ...params }
      }).then(({ data }) => data)
    },
    postCommonEdit({ commit, state }, data) {
      return mm.http({
        url: '/api/publicComponent/editPost',
        method: 'post',
        data
      }).then(({ data }) => {
        state.typeCache = {}
        return data
      })
    },
    getCommonUsedDetail({ commit, state }, params) {
      return mm.http({
        url: '/api/publicComponent/usage',
        method: 'get',
        params: { ...params }
      }).then(({ data }) => data)
    },
  },
  mutations: {}
}
export default common
